import React from 'react';
import styled from 'styled-components/native';
import SkeletonPlaceholder from '../skeletonPlaceholder';
import {getByScreenSize} from '../../utils/responsive';
import {useTheme} from 'styled-components';
import {Theme} from '../../theme/lightTheme';

const Container = styled.View`
  width: 100%;
  align-items: center;
`;

const DrugSearchListSkeleton = () => {
  const theme = useTheme() as Theme;
  return (
    <Container>
      {[0, 1, 2, 3, 4].map(item => (
        <SkeletonPlaceholder
          width={'90%'}
          key={item}
          aspectRatio={getByScreenSize(4, 5)}
          borderRadius={8}
          marginBottom={'2%'}
          backgroundColor={theme.text.border}
        />
      ))}
    </Container>
  );
};

export default DrugSearchListSkeleton;
